import { gql } from '@apollo/client'

export const EXPORT_MATERIAL_TAXONOMIES = gql`
  query TaxonomyPackagingMaterialsFunctionalUnits(
    $first: Int
    $after: String
    $where: TaxonomyPackagingMaterialsFunctionalUnitsGraphQLFilterInput
    $order: [TaxonomyPackagingMaterialsFunctionalUnitsGraphQLSortInput!]
  ) {
    taxonomyPackagingMaterialsFunctionalUnits(
      first: $first
      after: $after
      where: $where
      order: $order
    ) {
      nodes {
        id
        code
        name
        alias
        state
        class
        category
        categoryId
        transportCondition
        isVerified
        verifiedOn
        verifiedByName
        verifiedByEmail
        verificationComments
        researcherName
        researcherEmail
        created
        updated
        userEmail
        lastUpdatedName
        lastPublishedDate
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
